<div class="dialog-title">Assign Solicitor</div>
<form>
  <mat-form-field>
    <mat-label>Select Solicitor</mat-label>
    <mat-select multiple>
      <mat-option *ngFor=" let solicitor of solicitorlist" [value]=solicitor.id
        (onSelectionChange)="selectedSolicitor($event)">
        {{solicitor.name}}</mat-option>
    </mat-select>
  </mat-form-field>
</form>
<div class="dialog-buttons">
  <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="primary" (click)="submitForm()">Assign</button>
</div>